import React from 'react'
import { shape, string, boolean } from 'prop-types'
import triggerEvent from 'utils/dataLayer'


const MajorListItem = ({ major, type }) => (
  <>
    <a
      href={major.path}
      onClick={() => type && triggerEvent(`ga/${type}/card-major-related/${major.name}`)}
      className={`major-list-item ${major.hideOnDesktop ? 'major-list-item--desktop-hide' : 'swing-in-top-fwd'}`}
    >
      { major.name }
    </a>
    <style jsx>
      {`
        .major-list-item {
          font-weight: bold;
          font-size: 16px;
          padding: 16px;
          background-image: linear-gradient(112deg, #00beff, #0fc3c4);
          color: #fff;
          border-radius: 8px;
          margin: 8px;
          height: 72px;
          display: flex;
          align-items: center;
          width: calc(calc(100%/2) - 16px);
          min-width: 248px;
          scroll-snap-align: start;
          cursor: pointer;
          &:hover {
            text-decoration: none;
          }
          @media screen and (min-width: 768px) {
            &--desktop-hide {
              display: none;
            }
            min-width: unset;
            width: calc(calc(100%/3) - 16px);
          }
        }

        .swing-in-top-fwd {
          animation: swing-in-top-fwd 0.5s cubic-bezier(0.175, 0.885, 0.320, 1.275) both;
        }
        /* ----------------------------------------------
        * Generated by Animista on 2019-5-14 11:42:50
        * w: http://animista.net, t: @cssanimista
        * ---------------------------------------------- */

        /**
        * ----------------------------------------
        * animation swing-in-top-fwd
        * ----------------------------------------
        */
        @-webkit-keyframes swing-in-top-fwd {
          0% {  
            transform: rotateX(-100deg);
            transform-origin: top;
            opacity: 0;
          }
          100% {
            transform: rotateX(0deg);
            transform-origin: top;
            opacity: 1;
          }
        }
        @keyframes swing-in-top-fwd {
          0% {
            transform: rotateX(-100deg);
            transform-origin: top;
            opacity: 0;
          }
          100% {
            transform: rotateX(0deg);
            transform-origin: top;
            opacity: 1;
          }
        }
      `}
    </style>
  </>
)

MajorListItem.propTypes = {
  major: shape({
    name: string,
    path: string,
    hideOnDesktop: boolean,
  }),
}

export default MajorListItem
